import React from "react";
import { Grid } from "@mui/material";
import DashboardLayout from "../../layout/dashboard/DashboardLayout";
import TestSuitesTabContent from "../../components/project-dashboard/test-suites/TestSuitesTabContent";

const ProjectTeam = () => {

  return (
    <DashboardLayout>
      <Grid container spacing={2}>
        <Grid item md={12}>
            <TestSuitesTabContent/>
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};

export default ProjectTeam;
